import { z } from 'zod';
/**
 * Health contracts, per PRD VS-003 and TechSpec §6.1.
 *
 * Both endpoints are unauthenticated, so neither response may carry any
 * internal detail — a failing dependency is reported as `down` and nothing
 * more. The cause is logged, not served.
 */
export const HealthResponseSchema = z.object({
    status: z.literal('ok'),
    version: z.string(),
    /** Seconds since process start. */
    uptime: z.number().nonnegative(),
});
export const DEPENDENCY_STATUSES = ['up', 'down'];
export const DependencyCheckSchema = z.object({
    status: z.enum(DEPENDENCY_STATUSES),
    latencyMs: z.number().nonnegative(),
});
export const ReadyResponseSchema = z.object({
    status: z.enum(['ready', 'not_ready']),
    version: z.string(),
    uptime: z.number().nonnegative(),
    checks: z.object({
        postgres: DependencyCheckSchema,
        redis: DependencyCheckSchema,
    }),
});
//# sourceMappingURL=health.js.map